import { React, Fragment, memo, useState, useEffect } from 'react'
import {
  HeadingText,
  BodyText,
  Button,
  Row,
  Col,
  RadioButton,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PP_LOGGED_OUT_URL, PRIVACY_HOME } from '../../../constants/constants'
import asASlide from '../../common/as-a-slide'
import { fptiCustomImpression, fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const Welcome = memo((props) => {
  const [radioValue, setRadioValue] = useState()
  const [radioError, setRadioError] = useState(false)
  const [impressionDone, setImpressionDone] = useState(false)
  const { onModalNavigate, updateModalStore } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.WELCOME_IMPRESSION)
    }
  }, [])

  const handleCreateBtnClick = (event) => {
    event.preventDefault()
    if (radioValue) {
      setRadioError(false)
      let fptiData = loggedOutFPTI.START_REQUEST_BTN
      fptiData = {
        ...fptiData,
        page_type: radioValue,
      }
      fptiCustomClick(fptiData)
      updateModalStore({ radiovalue: radioValue })
      onModalNavigate(1)
    } else {
      setRadioError(true)
    }
  }

  const handleTrackClick = (event) => {
    event.preventDefault()
    const fptiData = loggedOutFPTI.ALREADY_REQUESTED_LINK
    fptiCustomClick(fptiData)
    location.href = `${PP_LOGGED_OUT_URL}/trackrequest`
  }

  const handleManageYourData = (event) => {
    event.preventDefault()
    const fptiData = loggedOutFPTI.MANAGE_YOUR_DATA_LINK
    fptiCustomClick(fptiData)
    location.href = PRIVACY_HOME
  }

  const handleChange = (event) => {
    setRadioValue(event.target.value)
  }

  return (
    <Fragment>
      <HeadingText
        id="loggedoutheader"
        size="sm"
        className="text-center requestForm-row"
      >
        <Message id="dsrLoggedout.introduction.header" />
      </HeadingText>

      <BodyText className="dataPrivacy-row">
        <Message id="dsrLoggedout.introduction.info" />
      </BodyText>

      <RadioButton
        id="data-option"
        name="data-option"
        onChange={handleChange}
        options={[
          {
            label: <Message id="dsrLoggedout.introduction.closeddata" />,
            value: 'closedaccountdata',
          },
          {
            label: <Message id="dsrLoggedout.introduction.guestdata" />,
            value: 'guestdata',
          },
        ]}
        value={radioValue}
        errorText={
          radioError ? <Message id="dsrLoggedout.choosedata.error" /> : ''
        }
      />

      <Row className="">
        <Col xs={12}>
          <div className="text-center requestForm-row">
            <Button
              id="createBtn"
              size="ld"
              onClick={handleCreateBtnClick}
              className="text-center"
            >
              <Message id="dsrLoggedout.introduction.createbtn" />
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <div className="text-center requestForm-row">
            <Button tertiary onClick={handleTrackClick}>
              <Message id="dsrLoggedout.introduction.alreadyrequestedlink" />
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <BodyText className="text-center requestForm-row">
            <Message id="dsrLoggedout.introduction.havepaypalaccount" />
          </BodyText>
        </Col>
      </Row>

      <Row>
        <Col>
          <BodyText className="text-center">
            <Message
              id="dsrLoggedout.introduction.manageyourdatahere"
              link={(innerMessage) => (
                <Button tertiary onClick={handleManageYourData}>
                  {innerMessage}
                </Button>
              )}
            />
          </BodyText>
        </Col>
      </Row>
    </Fragment>
  )
})

Welcome.displayName = 'Welcome'
export default asASlide({ position: 0 })(Welcome)
